import React from 'react';
import { components } from 'react-select';
import _size from 'lodash/size';

import { If } from 'utils';
import SelectMultiValue from './SelectMultiValue';

export default function SelectValueContainer({ children, ...props }) {
  const {
    isMulti,
    getValue,
    selectProps: { menuPosition }
  } = props;

  const isRelative = menuPosition === 'relative';
  const [values, input] = children;

  const selectedCount = _size(getValue());

  return (
    <components.ValueContainer {...props}>
      <If test={isRelative && isMulti && selectedCount} otherwise={values}>
        <SelectMultiValue {...props} isDisabled>
          <strong>{selectedCount}</strong> options selected
        </SelectMultiValue>
      </If>
      {input}
    </components.ValueContainer>
  );
}
